export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";